import { FC, Fragment, PropsWithChildren, ReactElement, useEffect, useState } from 'react';
import { getCurrentEnv, isCVSMobileApp } from '../lib/utils/utils';
import '../register-web-components';
import { localDefaultUrl } from '../helpers/helpers';

interface Props {
  pageName?: string;
  serviceProps?: string;
  serverSideRendered?: boolean;
  hdvCookie?: string;
  targetComponent?: string;
  slimHeader?: boolean;
  enableRefreshToken?: boolean;
}

const Header: FC<PropsWithChildren<Props>> = ({
  pageName = 'Account Lookup',
  serviceProps = 'enable_refresh_token=true',
  serverSideRendered = '',
  hdvCookie = 'on',
  targetComponent = '',
  slimHeader = false,
  children
}): ReactElement => {
  const [isMobileAppView, setIsMobileAppView] = useState<boolean | undefined>(false);
  const [headerData, setHeaderData] = useState<any>();

  useEffect(() => {
    setIsMobileAppView(isCVSMobileApp()); // this is used to hide the global header for framed in mobile apps
    if (slimHeader) {
      serviceProps += '&slim_header=true';
    }
    setHeaderData({
      pageName,
      serviceProps,
      serverSideRendered,
      hdvCookie,
      targetComponent,
      slimHeader
    });
  }, []);

  if (isMobileAppView) {
    return <Fragment>{children}</Fragment>;
  }

  const env = getCurrentEnv()?.toLowerCase();
  return (
    <Fragment>
      {headerData && (
        <div>
          <cvs-header-component
            page-name={headerData.pageName}
            base-url={env === 'local' ? localDefaultUrl : location.origin}
            service-props={headerData.serviceProps}
            server-side-rendered={headerData.serverSideRendered}
            hdv-cookie={headerData.hdvCookie}
            target-component={headerData.targetComponent}
          />
          {children}
        </div>
      )}
    </Fragment>
  );
};

export default Header;
